import React, { Component } from 'react';
import scrollToElement from 'scroll-to-element';
import { Link } from 'react-router-dom';

import FormContact from 'components/form-contact';
import MainHeader, {
  HeaderText,
  Underline,
} from 'components/shared/landing/main-header';
import SectionHeader from 'components/shared/landing/section-header';
import Card from 'components/shared/card';
import { IconList, IconListItem } from 'components/shared/landing/icon-list';
import Modal from 'components/shared/modal';
import Explainer from 'assets/videos/unyted-explainer-finalized.mp4';
import styles from './styles.module.scss';

const workshops = [
  {
    audience: 'Parents',
    type: 'Hybrid',
    lengthOfSessions: '1 hour',
    numberOfSessions: 4,
    goals:
      "Understand SEL, how it can help your child's development, and recognize when your child's school is doing it well. This workshop series will have some sessions in-person and some sessions online.",
    topics: ['SEL'],
    schedule: ['May Dates Coming Soon'],
  },
  {
    audience: 'Educators',
    type: 'Hybrid',
    lengthOfSessions: '2 hours',
    numberOfSessions: 2,
    goals:
      'Understand SEL, how it can help your students grow, and learn how to efficiently integrate SEL and academics in lessons.',
    topics: ['SEL'],
    schedule: ['Contact us to schedule'],
  },
];

class Workshops extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookModalOpen: false,
      reserveModalOpen: false,
    };

    this.onToggleBookModalClick = this.onToggleBookModalClick.bind(this);
    this.onToggleReserveModalClick = this.onToggleReserveModalClick.bind(this);
  }

  onToggleBookModalClick() {
    const { bookModalOpen } = this.state;
    this.setState({
      bookModalOpen: !bookModalOpen,
      reserveModalOpen: false,
    });
  }

  onToggleReserveModalClick() {
    const { reserveModalOpen } = this.state;
    this.setState({
      bookModalOpen: false,
      reserveModalOpen: !reserveModalOpen,
    });
  }

  render() {
    const { bookModalOpen, reserveModalOpen } = this.state;
    return (
      <div className={styles.workshops}>
        <MainHeader
          header={
            <HeaderText className={styles.headerText}>
              The keys to help learners{' '}
              <Underline>reach their full potential</Underline>
            </HeaderText>
          }
          subtext="Prepare yourself with the SEL Power Skills information and methods to best achieve your educator or parenting goals."
          onButtonClick={() => scrollToElement('#workshop-options')}
          buttonText="See Workshop Options"
          buttonClassName="apple"
          autoplayVideo={Explainer}
          flip
        />
        <section id="workshop-options" className={styles.workshopOptions}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader
                  tagline="real-world focused"
                  valueprop="SEL Workshops & Professional Development"
                />
              </div>
            </div>
            <div className="row">
              <div className={styles.parentWorkshops}>
                <div>
                  <h3>For Parents</h3>
                </div>
                <IconList>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Empower yourself with the latest SEL Power Skills
                    understanding & research.
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Ensure your child's school provides{' '}
                    <Link to="/sel-encyclopedia">
                      genuine SEL Power Skills development
                    </Link>
                    .
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Learn how SEL Power Skills apply to real-world situations.
                  </IconListItem>
                </IconList>
                <button onClick={() => scrollToElement('#workshops')}>
                  Find a session
                </button>
              </div>
              <div className={styles.educatorWorkshops}>
                <div>
                  <h3>For Educators</h3>
                </div>
                <IconList>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Learn to use SEL methods to boost academic achievement.
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Learn to use Unyted technology to get more results with less
                    work.
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Transform the relationships in your classroom to personalize
                    learning and benefit all.
                  </IconListItem>
                </IconList>
                <button onClick={this.onToggleBookModalClick}>
                  Book your school
                </button>
              </div>
            </div>
          </div>
        </section>
        <section id="workshops" className={styles.workshops}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader
                  tagline="accelerate your next moves"
                  valueprop="Certification Workshops"
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-12">
                {workshops.map(workshop => (
                  <Card>
                    <div className="d-flex flex-column justify-space-between flex-lg-row">
                      <div className="d-flex flex-column">
                        <h3 className="font-heavy">
                          {workshop.type} Workshop for {workshop.audience}
                        </h3>
                        <h5>
                          {workshop.numberOfSessions} sessions,{' '}
                          {workshop.lengthOfSessions} each
                        </h5>
                        <p>{workshop.goals}</p>
                      </div>
                      <div className="d-flex flex-column">
                        <IconList>
                          {workshop.schedule.map(date => (
                            <IconListItem
                              icon="check"
                              iconClassName="text-apple"
                            >
                              {date}
                            </IconListItem>
                          ))}
                        </IconList>
                      </div>
                    </div>
                    <button
                      onClick={
                        workshop.audience === 'Parents'
                          ? this.onToggleReserveModalClick
                          : this.onToggleBookModalClick
                      }
                      className={styles.cta}
                    >
                      {workshop.audience === 'Parents'
                        ? 'Reserve a spot'
                        : 'Book your school'}
                    </button>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </section>
        {bookModalOpen && (
          <Modal
            heading="Let's coordinate a Unyted workshop for your school or district"
            onClose={this.onToggleBookModalClick}
            size="lg"
            noFooter
            centered
          >
            <FormContact messageLabel="Please provide details on size, scope and goals" />
          </Modal>
        )}
        {reserveModalOpen && (
          <Modal
            heading="Reserve a spot in a Unyted SEL workshop"
            onClose={this.onToggleReserveModalClick}
            size="lg"
            noFooter
            centered
          >
            <FormContact messageLabel="Do you have any questions or comments?" />
          </Modal>
        )}
      </div>
    );
  }
}

export default Workshops;
